import {PlayersStatisticsApiModel} from "./players-statistics.api-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {PlayersStatisticsSubjectsDomainModel} from "./subjects/players-statistics.subjects.domain-model";
import {PlayersStatisticsCategoriesDomainModel} from "./categories/players-statistics.categories.domain-model";
import {PlayersStatisticsTableApiModel} from "./tables/players-statistics.table.api-model";
import {PlayersStatisticsCategoriesApiModel} from "./categories/players-statistics.categories.api-model";
import {PlayersStatisticsSubjectsApiModel} from "./subjects/players-statistics.subjects.api-model";
import {PlayersStatisticsTableDomainModel} from "./tables/players-statistics.table.domain-model";
import {LineupsMemberDomainModel} from "../lineups-member/lineups-member-domain-model";

export class PlayersStatisticsDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsApiModel;
  members: Array<LineupsMemberDomainModel>;

  constructor(apiModel: PlayersStatisticsApiModel, members: Array<LineupsMemberDomainModel>) {
    super(apiModel);

    this.members = members
  }

  get subjects(): PlayersStatisticsSubjectsDomainModel {
    const subjects: PlayersStatisticsSubjectsDomainModel = this.apiModel.subjects?.map((subject: PlayersStatisticsSubjectsApiModel) => new PlayersStatisticsSubjectsDomainModel(subject));

    return subjects;
  }

  get categories(): PlayersStatisticsCategoriesDomainModel {
    const categories: PlayersStatisticsCategoriesDomainModel = this.apiModel.categories?.map((category: PlayersStatisticsCategoriesApiModel) => new PlayersStatisticsCategoriesDomainModel(category));

    return categories;
  }

  get tables(): PlayersStatisticsTableDomainModel {
    const tables: PlayersStatisticsTableDomainModel = this.apiModel.tables?.filter(t => t.columns?.length > 0)?.map((table: PlayersStatisticsTableApiModel) => new PlayersStatisticsTableDomainModel(table, this.members));

    return tables;
  }

  get isExpandable(): Boolean {
    return this.apiModel.isExpandable;
  }
}
